import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from './color.styles';

export const globalStyles = makeStyles(theme => ({
	textCenter: {
		textAlign: 'center',
	},
	textRight: {
		textAlign: 'right',
	},
	textLeft: {
		textAlign: 'left',
	},
	left0: {
		left: 0,
	},
	textBold: {
		fontWeight: 'bold !important',
	},
	textNormal: {
		fontWeight: '400 !important',
	},
	fontWeight600: {
		fontWeight: '600 !important',
	},
	contentCenter: {
		justifyContent: 'center',
	},
	cursorPointer: {
		cursor: 'pointer',
	},
	mt2: {
		marginTop: '2px !important',
	},
	mt3: {
		marginTop: '3px !important',
	},
	mt5: {
		marginTop: '5px !important',
	},
	mt8: {
		marginTop: '8px !important',
	},
	mt10: {
		marginTop: '10px !important',
	},
	mt12: {
		marginTop: '12px !important',
	},
	mt16: {
		marginTop: '16px !important',
	},
	mt17: {
		marginTop: '17px !important',
	},
	mt20: {
		marginTop: '20px !important',
	},
	mt24: {
		marginTop: '24px !important',
	},
	mt25: {
		marginTop: '25px !important',
	},
	mt32: {
		marginTop: '32px !important',
	},
	mt43: {
		marginTop: '43px !important',
	},
	mb2: {
		marginBottom: '2px !important',
	},
	mb8: {
		marginBottom: '8px !important',
	},
	mb10: {
		marginBottom: '10px !important',
	},
	mb12: {
		marginBottom: '12px !important',
	},
	mb16: {
		marginBottom: '16px !important',
	},
	mb17: {
		marginBottom: '17px !important',
	},
	mb20: {
		marginBottom: '20px !important',
	},
	mb22: {
		marginBottom: '22px !important',
	},
	mb32: {
		marginBottom: '32px !important',
	},
	mb40: {
		marginBottom: '40px !important',
	},
	mb44: {
		marginBottom: '44px !important',
	},
	mb48: {
		marginBottom: '48px !important',
	},
	mb53: {
		marginBottom: '53px !important',
	},
	mb56: {
		marginBottom: '56px !important',
	},
	mb64: {
		marginBottom: '64px !important',
	},
	mb70: {
		marginBottom: '70px !important',
	},
	mb80: {
		marginBottom: '80px !important',
	},
	mb100: {
		marginBottom: '100px !important',
	},
	mb15: {
		marginBottom: '15px !important',
	},
	mb24: {
		marginBottom: '24px !important',
	},
	mb25: {
		marginBottom: '25px !important',
	},
	mb30: {
		marginBottom: '30px !important',
	},
	mtb8: {
		margin: '8px 0 !important',
	},
	mtb10: {
		margin: '10px 0',
	},
	mtb16: {
		margin: '16px 0',
	},
	mr2: {
		marginRight: 2,
	},
	mr8: {
		marginRight: 8,
	},
	mr10: {
		marginRight: '10px !important',
	},
	mr14: {
		marginRight: 14,
	},
	mr16: {
		marginRight: 16,
	},
	mr20: {
		marginRight: 20,
	},
	mr24: {
		marginRight: 24,
	},
	mr32: {
		marginRight: 32,
	},
	mr120: {
		marginRight: 120,
	},
	ml0: {
		marginLeft: 0,
	},
	ml6: {
		marginLeft: 6,
	},
	ml8: {
		marginLeft: 8,
	},
	m8: {
		marginLeft: 8,
	},
	ml16: {
		marginLeft: 16,
	},
	ml31: {
		marginLeft: 31,
	},
	ml46: {
		marginLeft: 46,
	},
	border_4: {
		borderRadius: 4,
	},
	noBorder: {
		border: 'none !important',
	},
	p0: {
		padding: 0,
	},
	p10: {
		padding: 10,
	},
	p16: {
		padding: 16,
	},
	p17: {
		padding: 17,
	},
	p24: {
		padding: 24,
	},
	p45: {
		padding: 45,
	},
	pt4: {
		paddingTop: 4,
	},
	pt20: {
		paddingTop: 20,
	},
	pt24: {
		paddingTop: 24,
	},
	pt30: {
		paddingTop: 30,
	},
	pt65: {
		paddingTop: 65,
	},
	pt160: {
		paddingTop: 160,
	},
	pt0: {
		paddingTop: 0,
	},
	ptb8: {
		paddingTop: 8,
		paddingBottom: 8,
	},
	pr8: {
		paddingRight: 10,
	},
	pr10: {
		paddingRight: 10,
	},
	pl10: {
		paddingLeft: 10,
	},
	h48: {
		height: 48,
	},
	w50_upMD: {
		[theme.breakpoints.up('md')]: {
			width: '50%',
		},
	},
	w48: {
		width: '48%',
	},
	w100: {
		width: '100%',
	},
	wFit: {
		width: 'fit-content',
	},
	fontSize11: {
		fontSize: 11,
	},
	fontSize12: {
		fontSize: 12,
	},
	fontSize14: {
		fontSize: 14,
	},
	fontSize16: {
		fontSize: '16px !important',
	},
	fontSize18: {
		fontSize: '18px !important',
	},
	fontSize40: {
		fontSize: 40,
	},
	lineHeight16: {
		lineHeight: 1.6,
	},
	lineHeight19: {
		lineHeight: 1.9,
	},
	fontSize90: {
		fontSize: 90,
	},
	textNoUnderline: {
		textDecoration: 'none',
	},
	textNoTransform: {
		textTransform: 'none',
	},
	aligncenter: {
		alignItems: 'center',
	},
	alignBaseLine: {
		alignItems: 'baseline',
	},
	colorFondoBlanco: {
		backgroundColor: '#FFFFFF',
	},
	colorRed: {
		color: COLORS.red,
	},
	colorGrey: {
		color: '#696969',
	},
	colorBlackGrey: {
		color: '#353535',
	},
	colorDarkGrey: {
		color: '#EBEBEB',
	},
	colorLightGrey: {
		color: '#FAFAFA',
	},
	colorUploadsGrey: {
		color: '#8B8B8B',
	},
	colorPink: {
		color: '#AC2188',
	},
	colorBlue: {
		color: '#1C6FC9',
	},
	colorLinkBlue: {
		color: '#175DA8',
	},
	errorMessage: {
		color: '#f44336',
		paddingBottom: 10,
		fontSize: 12,
	},
	icon: {
		height: 80,
		width: 80,
		margin: '0 auto',
		marginBottom: 6,
		'&.MuiSvgIcon-root': {
			height: 80,
			width: 80,
			margin: '0 auto',
			marginBottom: 16,
		},
	},
	colorIconSuccess: {
		'&.MuiSvgIcon-root': {
			color: '#00BD1E',
		},
	},
	dBlock: {
		display: 'block',
	},
	dFlex: {
		display: 'flex',
	},
	dNone: {
		display: 'none',
	},
	flipIcon: {
		'&.MuiSvgIcon-root': {
			transform: 'rotateY(180deg)',
		},
	},
	contentWrapperWithPadding: {
		padding: '0px 24px',
		[theme.breakpoints.up('md')]: {
			padding: '0px 40px 20px 40px',
		},
	},
	flexCenter: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	flexStart: {
		alignItems: 'flex-start',
	},
	flexJustifyCenter: {
		display: 'flex',
		justifyContent: 'center',
	},
	flexJustifyLeft: {
		display: 'flex',
		justifyContent: 'left',
	},
	flexJustifyRight: {
		display: 'flex',
		justifyContent: 'right',
	},
	attachDocsContent: {
		padding: '0 24px',
		display: 'flex',
		justifyContent: 'space-between',
		flexFlow: 'column nowrap',
		flex: 1,
	},
	footerLink: {
		width: 'auto',
		display: 'flex',
		alignItems: 'center',
		'flex-flow': 'column nowrap',
		justifyContent: 'flex-end',
		marginBottom: 32,
		paddingTop: 24,
		[theme.breakpoints.up('sm')]: {
			gap: 16,
		},
	},
	textBreakWord: {
		overflowWrap: 'break-word',
	},
	dividerMultiColor: {
		'&.MuiDivider-root': {
			background:
				'linear-gradient(90deg, #1C6FC9 0%, #CE28A3 36.98%, #E62619 71.35%, #F3B524 100%)',
		},
	},
	fw700: {
		fontWeight: 700,
	},
	fw600: {
		fontWeight: 600,
	},
	fontSize42: {
		fontSize: 42,
	},
	flexDirectionColumn: {
		display: 'flex',
		flexDirection: 'column',
	},
	flexDirectionReverseRow: {
		display: 'flex',
		flexDirection: 'row-reverse',
	},
	alignItemsCenter: {
		alignItems: 'center',
	},
	pl29: {
		paddingLeft: 29,
	},
	w90: {
		width: '90%',
	},
	pb16: {
		paddingBottom: 16,
	},
	pb32: {
		paddingBottom: 32,
	},
	w430: {
		width: 430,
	},
	plr24: {
		padding: '0 24px',
	},
	plr43: {
		padding: '0 43px',
	},
	pt8: {
		paddingTop: 8,
	},
	pt16: {
		paddingTop: 16,
	},
	pb8: {
		paddingBottom: 8,
	},
	pb24: {
		paddingBottom: 24,
	},
	colorBlack: {
		color: COLORS.black,
	},
	colorPrimary: {
		color: `${COLORS.primary} !important`,
	},
	colorSecondary: {
		color: COLORS.secondary,
	},
	colorTertiary: {
		color: COLORS.tertiary,
	},
	backgroundPrimary: {
		backgroundColor: `${COLORS.primary} !important`,
	},
	backgroundSecondary: {
		backgroundColor: COLORS.secondary,
	},
	link: {
		color: COLORS.primary,
		textDecoration: 'none',
		fontWeight: 'bold',
		cursor: 'pointer',
		'&:hover': {
			textDecoration: 'none',
		},
	},
	bottom0: {
		bottom: 0,
	},
	positionAbsolute: {
		position: 'absolute',
	},
}));
